<template>
  <nav class="bg-gradient-to-r from-primary-500 to-primary-600 shadow-xl border-b border-white/20">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <!-- Logo/Brand -->
        <div class="flex items-center">
          <div class="flex items-center space-x-2">
            <div class="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
              </svg>
            </div>
            <span class="text-xl font-bold text-white hidden sm:block">Kanban Board</span>
            <div class="text-xl font-bold text-white block sm:hidden leading-tight">
              <div>Kanban</div>
              <div>Board</div>
            </div>
          </div>
        </div>
        
        <!-- Navigation Links -->
        <div class="flex items-center space-x-1">
          <button 
            @click="goToHome"
            :class="['px-2 sm:px-4 py-2 rounded-lg transition-all duration-200 flex items-center', $route.path === '/' ? 'bg-white/20 text-white font-semibold shadow-inner' : 'text-white/80 hover:text-white hover:bg-white/10']"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline-block mr-1 sm:mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
            </svg>
            <span class="hidden sm:inline">当前看板</span>
            <div class="block sm:hidden text-xs leading-tight">
              <div>当前</div>
              <div>看板</div>
            </div>
          </button>

          <button 
            @click="goToBoards"
            :class="['px-2 sm:px-4 py-2 rounded-lg transition-all duration-200 flex items-center', $route.path === '/boards' ? 'bg-white/20 text-white font-semibold shadow-inner' : 'text-white/80 hover:text-white hover:bg-white/10']"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline-block mr-1 sm:mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <span class="hidden sm:inline">看板管理</span>
            <div class="block sm:hidden text-xs leading-tight">
              <div>看板</div>
              <div>管理</div>
            </div>
          </button>
          
          <button 
            @click="goToTeams"
            :class="['px-2 sm:px-4 py-2 rounded-lg transition-all duration-200 flex items-center', $route.path === '/teams' ? 'bg-white/20 text-white font-semibold shadow-inner' : 'text-white/80 hover:text-white hover:bg-white/10']"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline-block mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span class="hidden sm:inline">团队管理</span>
            <div class="block sm:hidden text-xs leading-tight">
              <div>团队</div>
              <div>管理</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goToHome = () => {
  router.push('/')
}

const goToTeams = () => {
  router.push('/teams')
}

const goToBoards = () => {
  router.push('/boards')
}
</script>

<style scoped>
nav {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
</style>